import React from "react";
import Button from "../../Common/Components/ButtonComponent/Button";
import DescriptionHtmlCode from "../../Common/Components/HtmlCode/DescriptionHtmlCode";

function FAQSegmentCard({
  button,
  handleInputChange,
  index,
  errors,
  removeButton,
  isEditable,
  isLoading,
  pageId,
  segmentId,
}) {
  return (
    <div className="bg-white border border-black-600 rounded-[5px] px-4 py-4">
      <label className="inline-block mb-2 text-base font-medium">
        Question Text
      </label>
      <input
        disabled={!isEditable}
        type="text"
        value={button.question_text}
        onChange={(e) =>
          handleInputChange(index, "question_text", e.target.value)
        }
        className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
        placeholder="Enter question text"
      />
      {errors.faqs[index]?.question_text && (
        <p className="text-sm text-red-500">
          {errors.faqs[index].question_text}
        </p>
      )}
      <label className="inline-block mb-2 text-base font-medium">
        Answer Text
      </label>
      <textarea
        disabled={true}
        data-type="text"
        rows={4}
        value={button.answer_text}
        onChange={(e) =>
          handleInputChange(index, "answer_text", e.target.value)
        }
        className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
        placeholder="Enter answer text"
      />
      {errors.faqs[index]?.answer_text && (
        <p className="text-sm text-red-500">{errors.faqs[index].answer_text}</p>
      )}
      {isEditable ? (
        <DescriptionHtmlCode
          content={button.answer_text}
          setContent={(e) => handleInputChange(index, "answer_text", e)}
        />
      ) : null}

      {/* Remove Segment Button */}
      <div className="flex justify-end mt-2">
        <Button
          btnText="Remove"
          disabled={!isEditable}
          isLoading={isLoading}
          pageId={pageId}
          id={segmentId}
          onClick={() => removeButton(index)}
          disabledClassName={
            "text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
          }
          className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
        />
      </div>
    </div>
  );
}

export default FAQSegmentCard;
